<script setup>
import {onMounted} from "vue";
import {useRoute, useRouter} from 'vue-router'
import {redirectToLogin} from '@/Helper';
import {useBaseStore} from '@/stores/BaseStore';
import config from "@/composables/Config";

const store = useBaseStore();
const route = useRoute()
const router = useRouter()
let token = route.query.t

async function checkAccess() {
    try {
        if (!token) {
            redirectToLogin(window.location.href);
        }

        const loggedIn = await store.loginUser(token);
        if (!loggedIn) { //login failed
            redirectToLogin(window.location.href);
        }

        const intendedPath = localStorage.getItem(config.general.intended_url);
        if (intendedPath) {
            localStorage.removeItem(config.general.intended_url);
            window.location.href = intendedPath
        } else {
            await router.replace({name: 'dashboard'});
        }
    } catch (error) {
        console.error('Error logging in user:', error);
    }
}

onMounted(() => {
    checkAccess()
})
</script>

<template>
    <div class="flex h-screen">
        <div class="m-auto">
            <div class="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900"></div>
        </div>
    </div>
</template>